import React from 'react';

import { Grid, makeStyles, Typography } from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    padding: '16px',
  },
  name: {
    wordBreak: 'break-all',
  },
}));

const BaseDetails = ({ url, name, params }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item>
        <Typography gutterBottom={true}>{name} Link Details</Typography>
      </Grid>

      <Grid item container>
        <Grid item xs={12}>
          <Typography color={'textSecondary'}>URL</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.name}>{url}</Typography>
        </Grid>
      </Grid>

      {params?.additionalParams ? (
        <Grid item container>
          <Grid item xs={12}>
            <Typography color={'textSecondary'}>Additional params</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.name}>
              {params?.additionalParams}
            </Typography>
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};

const DeepLinkDetails = ({ url, name }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item>
        <Typography gutterBottom={true}>{name} Link Details</Typography>
      </Grid>

      <Grid item container>
        <Grid item xs={12}>
          <Typography color={'textSecondary'}>URL</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.name}>{url}</Typography>
        </Grid>
      </Grid>

      {url?.additionalData?.map(({ fieldName, name }, index) => (
        <Grid item container xs={6} key={index}>
          <Grid item xs={12}>
            <Typography color={'textSecondary'}>{fieldName}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.name}>{name}</Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

const AgencyDetails = ({ url, name, params }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item>
        <Typography gutterBottom={true}>{name} Link Details</Typography>
      </Grid>

      <Grid item container>
        <Grid item xs={12}>
          <Typography color={'textSecondary'}>Partner name</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.name}>
            {params?.partnerName}
          </Typography>
        </Grid>
      </Grid>

      <Grid item container>
        <Grid item xs={12}>
          <Typography color={'textSecondary'}>URL</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.name}>{url}</Typography>
        </Grid>
      </Grid>

      {params?.additionalParams ? (
        <Grid item container>
          <Grid item xs={12}>
            <Typography color={'textSecondary'}>Additional params</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.name}>
              {params?.additionalParams}
            </Typography>
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};
// TODO: use ids insteadof name
const Info = ({ url, type, params }) => {
  switch (type.id) {
    case 6:
    case 4:
    case 3:
    case 1:
    case 0:
      return <BaseDetails url={url} name={type.name} params={params} />;
    case 5:
      return <AgencyDetails url={url} name={type.name} params={params} />;
    case 2:
      return <DeepLinkDetails url={url} name={type.name} params={params} />;
    default:
      return null;
  }
};

export default Info;
